import {FeatureList, GameConfig} from "../../../../GameConfig";
import {AnimUtils} from "../../../../utils/AnimUtils";
import {gsap} from "gsap";
import {HOTBGameData} from "../../../../server/HOTBData";
import {HOTB} from "../../../../HOTB";
import {ExtendedGameModel} from "../../../../server/ExtendedGameModel";
import {ExtendedGameMode} from "../../../../server/ExtendedGameMode";

export class TopReelFeature extends PIXI.Container {
    protected _spine: PIXI.spine.Spine;

    private _pushOutPosX: number = -240;
    private _pushInPosX: number = 950;

    constructor(reelId: number, featureName: string) {
        super();
        this.reelId = reelId;
        this.featureName = featureName;
        this.init();
    }

    private _dropPosId: number = -1;

    get dropPosId(): number {
        return this._dropPosId;
    }

    set dropPosId(value: number) {
        this._dropPosId = value;
    }

    private _featureName: string;

    get featureName(): string {
        return this._featureName;
    }

    set featureName(value: string) {
        this._featureName = value;
    }

    private _reelId: number;

    get reelId(): number {
        return this._reelId;
    }

    set reelId(value: number) {
        this._reelId = value;
    }

    public pushIn(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            bufferX: number = 159,
            slideInAnim: string = "1_slideIn",
            slideStopAnim: string = "2_slideStop",
            slideIdleAnim: string = "3_slideIdle";

        tl.to(this.position, {
            x: ((GameConfig.symbolWidth * this.reelId) + bufferX),
            duration: GameConfig.pushItemDuration,
            onStart: (): void => {
                this.playAnimation(slideInAnim, false);
            }
        });

        tl.add(this.playAnimation(slideStopAnim, false));
        tl.add(this.playAnimation(slideIdleAnim, true));

        return tl;
    }

    public pushOut(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this.position, {
            x: this._pushOutPosX,
            duration: GameConfig.pushItemDuration,
            ease: "sine.inOut",
            onComplete: (): void => {
                this.parent.removeChild(this);
            }
        });

        return tl;
    }

    public updateAttributes(reelId: number): void {
        this.reelId = reelId;
        this.setDropPosId();
    }

    public startDrop(finalPosY: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            this.playAnimation("5_dropStart"),
            gsap.to(this.position, {
                y: finalPosY,
                duration: GameConfig.itemDropTime
            })
        ]);

        return tl;
    }

    public finishDrop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(this.playAnimation("6_dropEnd"));

        return tl;
    }

    protected playAnimation(animToPlay: string, isLooped: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(AnimUtils.playSpineAnimation({
            spineObj: this._spine,
            animation: animToPlay,
            playLoop: isLooped
        }));

        return tl;
    }

    private init(): void {
        this.createSpine();
        this.setPosition();
        this.setInitialAnimation();
        this.setDropPosId();
    }

    private createSpine(): void {
        let spinePath: string = "";

        if (this.featureName === FeatureList.WILD) {
            spinePath = "featureWild"
        } else if (this.featureName === FeatureList.XNUDGE) {
            spinePath = "featureXNudge"
        } else if (this.featureName === FeatureList.DEAD) {
            spinePath = "featureDead";
        } else if (this.featureName === FeatureList.LAUNCH) {
            spinePath = "featureLaunch";
        } else if (this.featureName === FeatureList.MAGA_CAP) {
            spinePath = "featureCap";
        } else {
            //do nothing
        }

        if (spinePath) {
            this._spine = AnimUtils.createNewSpine({
                path: spinePath,
                name: spinePath,
                pos: new PIXI.Point(0, 0),
                initShow: true
            });

            this.addChild(this._spine);
        } else {
            debugger;
            throw new Error("--gg-- check for spinePath - TopReelFeature");
        }
    }

    private setPosition(): void {
        this.position.set(this._pushInPosX, 87.5);
    }

    private setInitialAnimation(): void {
        this.playAnimation("0_static");
    }

    private setDropPosId(): void {
        const gameModel: ExtendedGameModel = HOTB.model;

        if (gameModel.data.nextMode !== ExtendedGameMode.NORMAL && !(gameModel.isRestore)) {
            const gameData: HOTBGameData = gameModel.gameData;

            this.dropPosId = gameData.deleteMap[this.reelId].filter(value => value).length - 1;
        }
    }

    public getAnimDuration(animName: string): number {
        return AnimUtils.getSpineDuration(this._spine, animName);
    }
}